import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
//import { MatSidenav } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class AppData {
	public  keyApiKeyHeader: string = "apiKeyHeader";

	//public  isAuthenticated: Subject<boolean> = new Subject<boolean>(); 
	public  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public	authErroMsg: string;
	
	public  loginInvalid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 
	public  userId: string = "";
	public  user: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public  loginSuccessToken: string = ""; 
	public  allPrivileges: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	public  allRoles: BehaviorSubject<any> = new BehaviorSubject<any>([]);
	
	public  companyTypes;
	public  individualTypes;
	public  addressTypes;
	public  contactTypes;
	
	// Drawer/pannel related variable
	public isLeftNavActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isRightNavActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	//public drawerVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public leftNavMenuDrawer: BehaviorSubject<any> = new BehaviorSubject(null);
	public rightNavMenuDrawer: BehaviorSubject<any> = new BehaviorSubject(null);
	
	public selectedComapnyId;
	
	// Using "allPrivileges" below variable will get populated.
	// availablePrivileges = {'CREATE_COMPANY':true, 'UPDATE_TEACHER':true, ...};
	public availablePrivileges: BehaviorSubject<any> = new BehaviorSubject<any>({});
}
